import React, { useState, useEffect } from 'react';

import MainPagetitle from '../../layouts/MainPagetitle';

import documentService from '../../api/services/documentService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader'; 
import { Link, useNavigate, useParams } from 'react-router-dom';
import swal from "sweetalert";
import AdminPdfprotocolService from '../../api/services/AdminPdfprotocolService';

const Pdfprotocol = () => {
    var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL;
    const [Pdfprotocol, setPdfprotocol] = useState([]);
    const navigate = useNavigate();
    const params = useParams();
    const [isLoading, setisloading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records =Array.isArray(Pdfprotocol) && Pdfprotocol.length > 0
    ? Pdfprotocol.slice(firstIndex, lastIndex)
    : [];
    const npage = Math.ceil((Array.isArray(Pdfprotocol) ? Pdfprotocol.length : 0) / recordsPage);
    const number = [...Array(npage + 1).keys()].slice(1);
   
    
    useEffect(() => {
        if (localStorage.getItem("admintoken")) {
            // getDocument();
            getPdfprotocol(params.id);

        }
        else {
            navigate('/')
        }
    }, []);
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    function changeCPage(id) {
        setCurrentPage(id);
    }

    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    } 

    const getPdfprotocol= async (id) => {
        try {
            let Pdfprotocol = await AdminPdfprotocolService.index(id).json();
            console.log("Pdfprotocol : ",Pdfprotocol);
            
            setPdfprotocol(Pdfprotocol.data)
            setisloading(false);
        } catch (error) {

        }

    }

    const handleDelete = async (e) => {

        try {
            let responseData = await AdminPdfprotocolService.destroy(e).json()
            if (responseData.status === true) {
                swal("Pdf Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getPdfprotocol(params.id);
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json(); 
            }
        }
    }
    return (
        <>
            <MainPagetitle mainTitle="Pdf Protocol" pageTitle={'Pdf Protocol'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <div>
                                            <h4 className="heading mb-0">Pdf Protocol Listing</h4>
                                        </div>
                                        <div> 
                                            <button className="btn btn-primary btn-sm ms-1" onClick={() => navigate(`/admin/pdfadd/${params.id}`)}> Add PDF </button>                                            
                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>PDF Name</th> 
                                                    <th>PDF</th> 
                                                    <th className="d-flex">Action</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {records.length > 0 ? (
                                                    records.map((item, index) => {

                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="products">
                                                                        <h6>{index + 1}</h6>
                                                                    </div>
                                                                </td>  
                                                                <td>  
                                                                    {item.pdfname}
                                                                </td>
                                                                <td>  
                                                                    {item.pdf}
                                                                    <a className="btn btn-primary btn-sm ms-1" href={imageUrl + 'Pdfprotocol/' + item.pdf} target='_blank' >View</a>
                                                                </td>
                                                                <td>
                                                                <div className="d-flex">
                                                                <Link
                                                                    to={`/admin/pdfedit/${item.id}`}
                                                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                                                >
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </Link>
                                                                    <Link
                                                                        onClick={() =>
                                                                            swal({
                                                                                title: "Are you sure?",
                                                                                text: "Once deleted, you will not be able to recover this data!",
                                                                                icon: "warning",
                                                                                buttons: true,
                                                                                dangerMode: true,
                                                                            }).then((willDelete) => {
                                                                                if (willDelete) {
                                                                                    (handleDelete(item.id));
                                                                                }
                                                                            })
                                                                        }

                                                                        className="btn btn-danger shadow btn-xs sharp"
                                                                    >
                                                                        <i className="fa fa-trash"></i>
                                                                    </Link>
                                                                    </div>
                                                                </td>

                                                            </tr>
                                                        )
                                                    })
                                                    ) : (
                                                    <tr style={{ textAlign: 'center' }}>

                                                        <td colSpan={12}>
                                                            <div className='text-center'>No records found</div>
                                                        </td>
                                                    </tr>

                                                )
                                                }
                                            </tbody>
                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {Array.isArray(Document) && Document.length < lastIndex ? Document.length : lastIndex}
                                                {" "}of {Array.isArray(Document) ? Document.length : 0} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default Pdfprotocol;